import React from "react";

class LessStress extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="LessStress">
        <h2>You’re 16 Ounces Away From Less Stress</h2>
        <p>You can continue to follow the teachers who preach “practice longer to feel better.” In the process, you’ll try giving up other workouts like biking, hiking, running or weights.</p>
        <p>You’ll hope that’ll give you the extra time and energy to do more poses, feel calmer or have less pain. But you’ll probably resent missing out on things you love.</p>
        <p>Or you’ll cut out social events with friends and family for more practice time. They’ll feel sad that you’re not around and you’ll feel guilty for blowing them off.</p>
        <p>Because adding more practice time to a busy life isn’t sustainable, you’ll give up more often than you’ll want to admit. You’ll continue to be stressed by juggling way too many balls daily.</p>
        <p>Life’s too short to live it like this...</p>
        <p>...when a drink is all it takes to have more effective yoga sessions and keep the yoga buzz lingering longer.</p>
        <p>With Yoga Flow, you’ll begin yoga in a mindset most people only feel at the end of their session. Calm, present, and psyched to get on your mat.</p>
        <p>You’ll focus better and be more in tune with your body and mind. You’ll feel yoga’s sweet benefits–like suppleness and happiness–hours after the bell brings you out of savasana.</p>
        <p>You’ll feel less guilty about eating-on-the-run because your body will get wholesome Ayurvedic supplements. Without the hassle of taking extra tablets or mixing up powders.</p>
        <p>You’ll nourish your skin, cells and digestion by drinking extra water (that’s not bland and boring).</p>
        <p>You’ll feel proud of treating your ONE and only body to a daily dose of wellness.</p>
      </div>
    );
  }
}

export default LessStress;


// WEBPACK FOOTER //
// ./src/buy/less-stress.js